(function ($) {
    'use strict';
    /**
     * adds a wrapper element around password inputs
     * and adds a switch to display the characters
     */
    $.addPwSwitch = (function () {
        $('input[type="password"]').not('.password-wrapper input').each(function(){
            var $_this = $(this);
            var $pwSwitch = $('<i class="fas fa-eye pw-switch"></i>')
            .off('click.togglepw')
            .on('click.togglepw', function(){
                if($_this.attr('type') === 'text'){
                    $_this.attr('type', 'password');
                }else{
                    $_this.attr('type', 'text');
                }
                
                $(this).toggleClass(['fa-eye', 'fa-eye-slash']);
            });
            
            $(this).wrap('<span class="password-wrapper"></span>').after($pwSwitch);
        });
    });
}(jQuery)); //(function ( $ )    